import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=55fa2b37&"
import script from "./Activity.vue?vue&type=script&lang=ts&"
export * from "./Activity.vue?vue&type=script&lang=ts&"
import style0 from "./Activity.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports